import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiScrollbar, TuiScrollable } from '@taiga-ui/core';
import { RegistrationModule } from '@src/app/modules/registration';

import { RegistrationPageComponent } from './registration-page.component';

@NgModule({
  declarations: [RegistrationPageComponent],
  imports: [CommonModule, RegistrationModule, TuiScrollbar, TuiScrollable],
})
export class RegistrationPageModule {}
